const initialState = {
    FBRBuyerList: [],
    FBRBuyerDataList: [],
    isFetchingFBRBuyer: false,
    isAddingFBRBuyer: false,
};

const FBRBuyerReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_ADD_FBR_BUYER":
            return { ...state, isAddingFBRBuyer: true };
        case "SUCCESS_ADD_FBR_BUYER":
            return { ...state, FBRBuyerList: action.payload, isAddingFBRBuyer: false, };
        case "ERROR_ADD_FBR_BUYER":
            return { ...state, isAddingFBRBuyer: false };


        case "REQUEST_GET_FBR_BUYER":
            return { ...state, isFetchingFBRBuyer: true };
        case "SUCCESS_GET_FBR_BUYER":
            return { ...state, FBRBuyerDataList: action.payload.data, isFetchingFBRBuyer: false, };
        case "ERROR_GET_FBR_BUYER":
            return { ...state, };


        default:
            return state;
    }
};
export default FBRBuyerReducer;